import "./App.css";
import React from "react";
import { Timer } from "./components/Timer";

function App() {
  return (
    <div className="App">
      <main className="App-container">
        <div className="App-body">
          <Timer />
        </div>
      </main>
    </div>
  );
}

export default App;
